import { render } from "./TeamItem.vue?vue&type=template&id=291c6742&ts=true"
import script from "./TeamItem.vue?vue&type=script&lang=ts"
export * from "./TeamItem.vue?vue&type=script&lang=ts"

import "./TeamItem.vue?vue&type=style&index=0&id=291c6742&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__